import baseAPI from '@/api/base';
import { EditEmployeePayroll, GetEmployeePayroll, RegisterEmployeePayroll } from '@/dtos/employee_payroll.dto';
import {
  DELETE_EMPLOYEE_PAYROLL_URL,
  EDIT_EMPLOYEE_PAYROLL_URL,
  GET_EMPLOYEE_PAYROLL_URL,
  GET_EMPLOYEE_PAYROLL_STATS_URL,
  REGISTER_EMPLOYEE_PAYROLL_URL,
  TOGGLE_EMPLOYEE_PAYROLL_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeePayroll {
  static getEmployeePayrolls = async (getEmployeePayroll: GetEmployeePayroll): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_PAYROLL_URL, {
      params: getEmployeePayroll,
    });
    console.log('response', response);
    return response;
  };

  static getEmployeePayrollStats = async (getEmployeePayroll: GetEmployeePayroll): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_PAYROLL_STATS_URL, {
      params: getEmployeePayroll,
    });
    console.log('response', response);
    return response;
  };

  static registerEmployeePayroll = async (
    registerEmployeePayroll: RegisterEmployeePayroll
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_EMPLOYEE_PAYROLL_URL, {
      ...registerEmployeePayroll,
    });
    console.log('response', response);
    return response;
  };

  static editEmployeePayroll = async (editEmployeePayroll: EditEmployeePayroll): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_PAYROLL_URL, {
      ...editEmployeePayroll,
    });
    return response;
  };

  static toggleEmployeePayrollIsActive = async (
    editEmployeePayroll: EditEmployeePayroll
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EMPLOYEE_PAYROLL_IS_ACTIVE_URL,
      {
        ...editEmployeePayroll,
      }
    );
    return response;
  };

  static deleteEmployeePayroll = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EMPLOYEE_PAYROLL_URL}/${userId}`
    );
    return response;
  };
}

export default EmployeePayroll;
